import React from 'react';
import { cn } from '@/lib/utils';

const adaptabilityData = [
  { role: 'Entrepreneurs', percent: 19 },
  { role: 'Product & Product Marketing Management', percent: 30 },
  { role: 'Marketing', percent: 24 },
  { role: 'Consulting', percent: 30 },
  { role: 'Design/UI/UX', percent: 18 },
  { role: 'Operations', percent: 17 },
];

const AIAdaptabilityGraph = () => {
  return (
    <div className="mx-4 w-full rounded-2xl bg-gradient-to-b from-[#31E2B4] to-[#B5F1EA] p-6 md:max-w-5xl">
      <h2
        className={cn(
          'mb-6 text-center font-rubik text-[24px] font-medium capitalize leading-[20.4px] tracking-normal text-black',
          'md:text-[32px] md:leading-[26px]',
        )}
      >
        AI Adaptability Graph
      </h2>
      <div className="space-y-3">
        {adaptabilityData.map((item, index) => (
          <div
            key={index}
            className="flex flex-col md:flex-row md:items-center md:gap-4"
          >
            <div
              className={cn(
                'w-full font-rubik text-sm text-[10px] leading-[26px] tracking-normal text-black md:mb-0',
                'md:text-[20px] md:leading-[36px]',
              )}
            >
              {item.role}
            </div>
            <div className="flex w-full flex-col gap-2 md:w-3/5 md:flex-row md:items-center">
              <div className="relative h-3 w-full max-w-[500px] overflow-hidden rounded-full bg-white">
                <div
                  className="absolute top-0 left-0 h-full rounded-full bg-[#007A6D]"
                  style={{ width: `${item.percent}%` }}
                />
              </div>
              <span
                className={cn(
                  'w-[40px] font-rubik text-sm text-[10px] leading-[26px] tracking-normal text-black md:mb-0',
                  'md:text-[20px] md:leading-[36px]',
                )}
              >
                {item.percent}%
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AIAdaptabilityGraph;
